<ng-container
  *ngIf="learningObjectiveOrderData$ | async as learningObjectiveOrderData"
>
  <ng-container *ngIf="learningObjectiveData$ | async as learningObjectiveData">
    <ng-container *ngIf="selectedDomain$ | async as selectedDomain">
      <div class="grid-container">
        <div class="grid-learningobjective-info">
          <router-outlet> </router-outlet>
        </div>
        <div class="grid-brand-account p-3 d-flex">
          <button class="btn btn-none" (click)="openInfoPage()">
            <div class="text-primary">Groeimeter hoe werkt het?</div>
            <div class="small text-secondary">Handleiding</div>
          </button>
          <div class="ml-auto">
            <app-navbar></app-navbar>
          </div>
        </div>

        <div class="grid-switch-button p-3 text-left">
          <button
            class="ml-auto btn btn-lg bg-primary text-white mdi mdi-chevron-right"
            (click)="navigateToPlan()"
          >
            Plannen
          </button>
          <button
            class="ml-3 btn btn-lg bg-primary text-white"
            [routerLink]="['/dashboard']"
          >
            Startpagina
          </button>
        </div>

        <div class="grid-buttons bg-white">
          <div class="col p-3 d-flex justify-content-between">
            <ng-container
              *ngIf="(selectedCitoModule$ | async) === citomodules.Rekenen"
            >
              <div class="btn-group" dropdown>
                <button
                  id="domeinen"
                  dropdownToggle
                  type="button"
                  class="btn btn-light dropdown-toggle"
                  aria-controls="dropdown-basic"
                >
                  {{ selectedDomain.title }}<span class="caret"></span>
                </button>
                <ul
                  id="dropdown-basic"
                  *dropdownMenu
                  class="dropdown-menu"
                  role="menu"
                  aria-labelledby="domeinen"
                >
                  <ng-container
                    *ngIf="learningObjectiveOrderData.domains as domains"
                  >
                    <li
                      class="dropdown-item c-pointer"
                      [class.active]="domain.id == selectedDomain.id"
                      (click)="toDomain(domain.id)"
                      *ngFor="let domain of domains; let i = index"
                    >
                      {{ domain.title }}
                    </li>
                  </ng-container>
                </ul>
              </div>
            </ng-container>
            <ng-container>
              <div class="btn-group">
                <button
                  (click)="openModal(newlisttemplate)"
                  class="btn btn-light ml-3"
                >
                  Nieuwe lijst +
                </button>
                <button
                  [disabled]="
                    !learningObjectiveData.selectedLearningObjectiveOrder
                  "
                  class="btn btn-warning mdi mdi-delete ml-3"
                  (click)="openModal(dellisttemplate)"
                >
                  Verwijder huidige lijst
                </button>
              </div>
            </ng-container>
            <!-- <ng-container *ngIf="(selectedCitoModule$ | async) === citomodules.Spelling">
              <div class="btn-group"
                   dropdown>
                <button id="domeinen"
                        dropdownToggle
                        type="button"
                        class="btn btn-light dropdown-toggle"
                        aria-controls="dropdown-basic">
                  {{selectedDomain.title}}<span class="caret"></span>
                </button>
                <ul id="dropdown-basic"
                    *dropdownMenu
                    class="dropdown-menu"
                    role="menu"
                    aria-labelledby="domeinen">
                  <ng-container *ngIf="learningObjectiveOrderData.domains as domains">
                    <li class="dropdown-item c-pointer"
                        [class.active]="domain.id == selectedDomain.id"
                        (click)="null"
                        *ngFor="let domain of domains; let i = index">
                      {{ domain.title }}
                    </li>
                  </ng-container>
                </ul>
              </div>
            </ng-container> -->
            <div
              class="btn-toolbar align-items-center ml-auto"
              role="toolbar"
              aria-label="Toolbar with button groups"
            >
              <button
                type="button"
                [disabled]="
                  learningObjectiveData.selectedLearningObjectiveOrder
                    .isTemplate
                "
                (click)="toggleEditMode(true)"
                class="btn btn-outline-dark mr-2 mdi mdi-file-tree shadow-sm"
              >
                {{
                  !learningObjectiveOrderData.editMode
                    ? "Bewerk leerlijn"
                    : "Je zit in bewerkmodus"
                }}
              </button>

              <button
                type="button"
                [disabled]="!selectedLearningObjectiveInList"
                [class.disabled]="!selectedLearningObjectiveInList"
                [class.shadow-sm]="selectedLearningObjectiveInList"
                (click)="showInfo(selectedLearningObjectiveInList.code)"
                class="btn btn-outline-dark mdi mdi-information-outline mr-2"
              >
                Leerdoelinfo
              </button>

              <button
                type="button"
                *ngIf="learningObjectiveOrderData.editMode"
                [disabled]="
                  !learningObjectiveData.selectedLearningObjectiveOrder ||
                  !selectedLearningObjectiveInList ||
                  selectedLearningObjectiveInList?.inList
                "
                [class.disabled]="
                  !learningObjectiveData.selectedLearningObjectiveOrder ||
                  !selectedLearningObjectiveInList ||
                  selectedLearningObjectiveInList?.inList
                "
                [class.shadow-sm]="
                  !(
                    !learningObjectiveData.selectedLearningObjectiveOrder ||
                    !selectedLearningObjectiveInList ||
                    selectedLearningObjectiveInList?.inList
                  )
                "
                (click)="addLearningObjective(selectedLearningObjectiveInList)"
                class="btn btn-outline-dark mdi mdi-plus mr-2"
              >
                Voeg toe in lijst
              </button>

              <button
                type="button"
                *ngIf="learningObjectiveOrderData.editMode"
                [disabled]="!selectedLearningObjectiveInList?.inList"
                [class.disabled]="!selectedLearningObjectiveInList?.inList"
                [class.shadow-sm]="!!selectedLearningObjectiveInList?.inList"
                (click)="
                  removeLearningObjective(selectedLearningObjectiveInList)
                "
                class="btn btn-outline-dark mdi mdi-minus mr-2"
              >
                Verwijder uit lijst
              </button>
              <ng-container
                *ngIf="(selectedCitoModule$ | async) === citomodules.Rekenen"
              >
                <button
                  type="button"
                  (click)="
                    showInStructure(
                      learningObjectiveData.selectedLearningObjective?.domainId,
                      learningObjectiveData.selectedLearningObjective?.id,
                      selectedDomain.id
                    )
                  "
                  [disabled]="!learningObjectiveData.selectedLearningObjective"
                  [class.disabled]="
                    !learningObjectiveData.selectedLearningObjective
                  "
                  [class.shadow-sm]="
                    learningObjectiveData.selectedLearningObjective
                  "
                  class="btn btn-outline-dark mdi mdi-file-tree"
                >
                  Toon in structuur
                </button>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="grid-major-subject p-3 bg-white">
          <app-inline-edit
            #appInline
            class="flex-grow-1 h4 m-0"
            [value]="
              learningObjectiveData.selectedLearningObjectiveOrder
                ? learningObjectiveData.selectedLearningObjectiveOrder.title
                : ''
            "
            type="text"
            required="true"
            [disabled]="
              !learningObjectiveOrderData.editMode &&
              learningObjectiveData.selectedLearningObjectiveOrder
            "
            requiredMessage="REQUIREDMESSAGE"
            placeholder="Selecteer een lijst"
            (Save)="
              onSave(
                learningObjectiveData.selectedLearningObjectiveOrder.id,
                appInline.value
              )
            "
          >
          </app-inline-edit>
        </div>
        <ng-container
          *ngIf="
            !learningObjectiveOrderData.myLists ||
            learningObjectiveOrderData.myLists.length === 0
          "
        >
          <div class="grid-learningobjectives container-fluid overflow-scroll">
            <div class="empty-state empty-state h-100 m-0">
              <span class="mdi mdi-trending-up mdi-48px"></span>
              <h3>Je hebt nog geen eigen leerlijn.</h3>
              <p style="margin-top: 20px"></p>
              <div class="text-left">
                <button
                  (click)="openModal(newlisttemplate)"
                  class="btn btn-outline-primary"
                >
                  Klik hier
                </button>
                om een leerlijn aan te maken. <br />
                <p class="mt-2">
                  <strong>- Kies voor:</strong> Alle leerdoelen <br />
                </p>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            learningObjectiveOrderData.myLists &&
            learningObjectiveOrderData.myLists.length > 0 &&
            learningObjectiveData.selectedLearningObjectiveOrder.isTemplate
          "
        >
          <div class="grid-learningobjectives container-fluid overflow-scroll">
            <div class="empty-state h-100 m-0 row">
              <div class="col-10 col-md-8 col-lg-4">
                <span class="mdi mdi-trending-up mdi-48px"></span>
                <h3 class="mb-4">Selecteer een eigen leerlijn.</h3>
                <ul class="list-group">
                  <li
                    class="list-group-item list-group-item-action c-pointer"
                    *ngFor="
                      let learningObjectiveOrder of learningObjectiveOrderData.myLists
                    "
                    (click)="selectOrCopy(learningObjectiveOrder.id); decline()"
                  >
                    {{ learningObjectiveOrder.title }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container
          *ngIf="
            learningObjectiveOrderData.myLists &&
            learningObjectiveOrderData.myLists.length > 0 &&
            !learningObjectiveData.selectedLearningObjectiveOrder.isTemplate
          "
        >
          <ng-container *ngIf="(selectedCitoModule$ | async) === 0">
            <div class="grid-learningobjectives px-3 overflow-scroll">
              <app-learning-objective-categories
                class="position-relative d-block"
                (addLearningObjective)="addLearningObjective($event)"
                (removeLearningObjective)="removeLearningObjective($event)"
                (learningObjectiveSelected)="selectLearningObjective($event)"
                [domain]="selectedDomain"
                [learningObjectivesInList]="
                  learningObjectiveData.selectedLearningObjectiveOrder
                    ?.learningObjectives
                "
                [editMode]="
                  learningObjectiveOrderData.editMode &&
                  learningObjectiveData.selectedLearningObjectiveOrder
                "
                [selected]="selectedLearningObjectiveInList"
                [learningObjectivesOrdered]="
                  learningObjectiveData.selectedLearningObjectiveOrder
                "
              >
              </app-learning-objective-categories>
            </div>
          </ng-container>
          <ng-container *ngIf="(selectedCitoModule$ | async) === 1">
            <div
              class="grid-learningobjectives container-fluid overflow-scroll"
            >
              <app-learning-objective-categories-spelling
                *ngIf="
                  !learningObjectiveData.selectedLearningObjectiveOrder
                    ?.isTemplate
                "
                class="position-relative d-block"
                (addLearningObjective)="addLearningObjective($event)"
                (removeLearningObjective)="removeLearningObjective($event)"
                (learningObjectiveSelected)="selectLearningObjective($event)"
                [allLearningObjectives]="
                  learningObjectiveData.allLearningObjectives
                "
                [learningObjectivesInList]="
                  learningObjectiveData.selectedLearningObjectiveOrder
                    ?.learningObjectives
                "
                [editMode]="
                  learningObjectiveOrderData.editMode &&
                  learningObjectiveData.selectedLearningObjectiveOrder
                "
                [selected]="selectedLearningObjectiveInList"
                [learningObjectivesOrdered]="
                  learningObjectiveData.selectedLearningObjectiveOrder
                "
              >
              </app-learning-objective-categories-spelling>
            </div>
          </ng-container>
        </ng-container>

        <div class="grid-filters bg-white">
          <div class="row m-0 bg-white p-3 border-bottom d-flex">
            <app-filters
              class="flex-grow-1"
              [placeholdertext]="
                learningObjectiveData.selectedLearningObjectiveOrder
                  ? learningObjectiveData.selectedLearningObjectiveOrder.title
                  : ''
              "
              [disabled]="
                !learningObjectiveOrderData.editMode ||
                learningObjectiveOrderData.isLoading
              "
            >
            </app-filters>
            <ng-container *ngIf="learningObjectiveOrderData.isLoading">
              <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </ng-container>
            <div class="dropdown" #orderpickerdropdown="bs-dropdown" dropdown>
              <a
                dropdownToggle
                class="btn btn-link p-0 pl-2 text-primary border-0 mdi-22px mdi mdi-chevron-down-box"
              ></a>

              <ul
                *dropdownMenu
                class="dropdown-menu dropdown-menu-right"
                role="menu"
                aria-labelledby="lopicker-button"
              >
                <li
                  *ngFor="
                    let learningObjectiveOrder of learningObjectiveOrderData.myLists
                  "
                  (click)="selectOrCopy(learningObjectiveOrder.id)"
                  role="menuitem"
                  [class.active]="
                    learningObjectiveOrder.id ===
                    learningObjectiveData.selectedLearningObjectiveOrder?.id
                  "
                  class="dropdown-item cursor-pointer mdi mdi-file-document-box-outline"
                >
                  {{ learningObjectiveOrder.title }}
                </li>

                <li
                  class="divider dropdown-divider"
                  *ngIf="learningObjectiveOrderData.editMode"
                ></li>
                <li
                  class="dropdown-item px-4"
                  *ngIf="learningObjectiveOrderData.editMode"
                >
                  <button
                    [disabled]="
                      !learningObjectiveData.selectedLearningObjectiveOrder
                    "
                    class="btn btn-warning btn-block mdi mdi-delete"
                    (click)="openModal(dellisttemplate)"
                  >
                    Verwijder huidige lijst
                  </button>
                </li>
                <li
                  class="dropdown-item px-4"
                  *ngIf="learningObjectiveOrderData.editMode"
                >
                  <button
                    *ngIf="learningObjectiveOrderData.editMode"
                    class="btn btn-info btn-block mdi mdi-delete text-white"
                    (click)="openModal(newlisttemplate)"
                  >
                    Nieuwe lijst
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="grid-list-items position-relative overflow-scroll bg-white">
          <ng-container
            *ngIf="
              !learningObjectiveOrderData.isLoading &&
              learningObjectiveData.selectedLearningObjectiveOrder
            "
          >
            <div
              id="learningObjectiveList"
              dndDropzone
              dndEffectAllowed="copyMove"
              (dndDrop)="dropped($event)"
            >
              <div dndPlaceholderRef class="dropPlaceHolder"></div>

              <div
                class="d-flex align-items-stretch has-handle p-0 vertical-align-center"
                [class.c-pointer]="!learningObjectiveOrderData.editMode"
                [class.draggable-item]="learningObjectiveOrderData.editMode"
                *ngFor="
                  let learningObjective of learningObjectiveData.learningObjectivesInList;
                  let i = index;
                  trackBy: identifyLO
                "
                [ngClass]="
                  learningObjectiveData.selectedLearningObjective?.id ===
                  learningObjective.id
                    ? 'active-bg'
                    : 'bg-white'
                "
                [class.active]="
                  learningObjectiveData.selectedLearningObjective?.id ===
                  learningObjective.id
                "
                [id]="'orderlist-' + learningObjective.id"
                [dndDraggable]="learningObjective"
                [dndDisableIf]="!learningObjectiveOrderData.editMode"
              >
                <div
                  class="d-flex w-100 justify-content-between"
                  [class.c-pointer]="!learningObjectiveOrderData.editMode"
                  [style.border-left]="
                    '5px solid ' +
                    colorLightScale(
                      learningObjective.domainId,
                      learningObjective.subjectCode
                    )
                  "
                  (click)="
                    !learningObjectiveOrderData.editMode &&
                      setSelectLearningObjective(
                        learningObjective,
                        learningObjectiveData.selectedLearningObjective?.id ===
                          learningObjective.id
                      )
                  "
                >
                  <div
                    *ngIf="learningObjectiveOrderData.editMode"
                    class="align-self-center text-muted mdi mdi-drag-vertical mdi-24px cursor-grab"
                    dndHandle
                    title="Sleep om te herordenen"
                  ></div>
                  <app-learning-objective-view
                    class="h-100 py-2 border-bottom"
                    style="margin-right: 15px"
                    [selected]="
                      learningObjectiveData.selectedLearningObjective?.id ===
                      learningObjective.id
                    "
                    [learningObjective]="learningObjective"
                  >
                  </app-learning-objective-view>
                </div>
                <app-order-cursor
                  *ngIf="learningObjectiveOrderData.editMode"
                  (click)="cursorIndex = i; $event.stopPropagation()"
                  [active]="i === cursorIndex"
                ></app-order-cursor>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <ng-template #newlisttemplate>
        <div class="modal-body">
          <ng-container
            *ngIf="
              learningObjectiveOrderData.templateLists &&
              learningObjectiveOrderData.templateLists?.length > 0
            "
          >
            <p>Maak een nieuwe lijst op basis van</p>
            <ul class="list-group">
              <li
                class="list-group-item list-group-item-action c-pointer"
                *ngFor="
                  let learningObjectiveOrder of learningObjectiveOrderData.templateLists
                "
                (click)="selectOrCopy(learningObjectiveOrder.id); decline()"
              >
                {{ learningObjectiveOrder.title }}
              </li>
              <li
                class="list-group-item list-group-item-action c-pointer"
                (click)="createEmptyList(); decline()"
              >
                Lege lijst
              </li>
            </ul>
          </ng-container>

          <button
            type="button"
            class="btn btn-outline-primary mt-3"
            (click)="decline()"
          >
            Annuleren
          </button>
        </div>
      </ng-template>

      <ng-template #dellisttemplate>
        <div class="modal-body text-center">
          <p>
            Wil je de lijst "{{
              learningObjectiveData.selectedLearningObjectiveOrder?.title
            }}" verwijderen?
          </p>
          <button
            type="button"
            class="btn btn-primary-outline"
            (click)="decline()"
          >
            Annuleren
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="
              confirm(learningObjectiveData.selectedLearningObjectiveOrder?.id)
            "
          >
            Verwijderen
          </button>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>
